import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=3ff9153d&"
import script from "./TagEdit.vue?vue&type=script&lang=js&"
export * from "./TagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff9153d')) {
      api.createRecord('3ff9153d', component.options)
    } else {
      api.reload('3ff9153d', component.options)
    }
    module.hot.accept("./TagEdit.vue?vue&type=template&id=3ff9153d&", function () {
      api.rerender('3ff9153d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/TagEdit.vue"
export default component.exports